import React from "react";
import {
  Image,
  Button,
  Card,
  CardBody,
  Chip,
  Spinner,
} from "@heroui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import { IMAGES } from "../../../localConstants/images";
import { useGetProducts } from "../../../hooks/useGetProducts";
import { useWalletVerification } from "../../../hooks/useWalletVerification";
import { usePurchaseProduct } from "../../../hooks/usePurchaseProduct";

export function ProductShowcase() {
  const { address } = useGetAccountInfo();

  const { data: walletVerification } = useWalletVerification();
  const purchaseProduct = usePurchaseProduct();

  const handlePurchase = (productId: string, productName: string) => {
    if (!address) {
      alert("Please connect your wallet first");
      return;
    }

    if (!walletVerification?.valid) {
      alert("Please link your wallet in the mobile app first");
      return;
    }

    purchaseProduct.mutate({ productId, productName });
  };

  return (
    <div className="flex flex-col h-full p-8 bg-gradient-to-br from-neutral-900 via-neutral-950 to-black/80">
      <div className="mb-6 flex justify-center">
        <Image
          src={IMAGES.AINEXUS}
          alt="AiNexus Logo"
          className="h-14 w-auto"
        />
      </div>

      <h2 className="text-2xl font-bold text-white mb-2 text-center">
        Available Products
      </h2>

      <p className="text-neutral-400 text-center mb-6 max-w-md mx-auto text-sm">
        {address
          ? walletVerification?.valid
            ? "Choose a product to purchase"
            : "Link your wallet in the mobile app to make purchases"
          : "Connect your wallet to access exclusive products"}
      </p>

      {/* Wallet Status */}
      {address && (
        <div className="mb-6 flex justify-center">
          <Chip
            color={walletVerification?.valid ? "success" : "warning"}
            variant="flat"
            size="sm"
          >
            {walletVerification?.valid ? "Wallet Linked" : "Wallet Not Linked"}
          </Chip>
        </div>
      )}

      {/* Info sections */}
      <div className="mt-6 space-y-4">
        <div className="relative overflow-hidden bg-primary/20 rounded-xl p-4">
          <div className="flex items-center">
            <div className="flex-1">
              <h3 className="text-white font-semibold text-base mb-1">
                Credits
              </h3>
              <p className="text-xs text-white/70">
                Premium currency for advanced AI features
              </p>
            </div>
            <div className="relative">
              <Image
                src={IMAGES.GEMS}
                alt="Credits"
                className="h-16 w-16 object-contain relative z-10"
              />
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden bg-neutral-800/50 rounded-xl p-4">
          <div className="flex items-center">
            <div className="flex-1">
              <h3 className="text-white font-semibold text-base mb-1">Gold</h3>
              <p className="text-xs text-white/70">
                Primary in-game currency for marketplace purchases
              </p>
            </div>
            <div className="relative">
              <Image
                src={IMAGES.GOLD}
                alt="Gold"
                className="h-16 w-16 object-contain relative z-10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
